import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActiveList } from 'src/app/shared/generic/models/active-list';
import { interval } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { GenericFilter } from 'src/app/shared/generic/models/generic-filter';
import isEqual from 'lodash/isEqual';

@Component({
  selector: 'app-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss']
})
export class NotificationMenuComponent implements OnInit {
  initialNotificationList: any[];
  notificationList: any[];
  notificationsFilter: GenericFilter;
  unreadMessages: boolean;

  constructor(private http: HttpClient) {
    this.notificationsFilter = new GenericFilter({
      atributos: {},
      ordenacion: {
        fechaAlta: 'DESC'
      },
      clase: 'TTicketBase',
      claseUsuario: 'Aviso',
      pagina: 0,
      tamPagina: 5
    });
    this.unreadMessages = false;
  }

  ngOnInit() {
    // this.setUpPolling();
  }

  onBellClick() {
    this.unreadMessages = false;
  }

  /**
   * Inicializa el polling de notificaciones a la API Rest de la CMDB.
   */
  // setUpPolling(): void {
  //   interval(60000)
  //     .pipe(
  //       startWith(0),
  //       switchMap(() =>
  //         this.http.post(
  //           environment.gatewayEndpoints.cmdb + '/ticket/lista',
  //           this.notificationsFilter
  //         )
  //       )
  //     )
  //     .subscribe((notificationList: ActiveList) => {
  //       /* Si no hay elementos en la respuesta, viene un null que no permite compararlos correctamente en el siguiente condicional,
  //       así que se pasa a array vacío en caso de ser nulo */
  //       notificationList.elementos = notificationList.elementos || [];

  //       if (!isEqual(notificationList.elementos, this.notificationList)) {
  //         this.notificationList = notificationList.elementos || [];
  //         this.unreadMessages = true;
  //       }
  //     });
  // }
}
